var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "listPage" },
    [
      _c(
        "b-row",
        { staticClass: "mt-2 justify-content-start" },
        [
          _c(
            "b-col",
            { attrs: { cols: "4", lg: "2", xl: "1" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter mb-5",
                  on: {
                    click: function ($event) {
                      _vm.displayFilter = !_vm.displayFilter
                    },
                  },
                },
                [
                  _vm.displayFilter
                    ? _c("i", { staticClass: "fa-light fa-minus" })
                    : _c("i", { staticClass: "fa-light fa-plus" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("filter.fltr")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "4", lg: "2", xl: "1" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter mb-5",
                  on: {
                    click: function ($event) {
                      return _vm.refreshInbox()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-rotate-right" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.rfrsh")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.displayFilter
        ? _c(
            "b-row",
            { staticClass: "justify-content-start" },
            [
              _c(
                "b-col",
                {
                  staticClass: "filter-item mb-5",
                  attrs: { sm: "6", lg: "3", cols: "12" },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "filter-item-title",
                      attrs: { for: "orphan-reference" },
                    },
                    [_vm._v(_vm._s(_vm.$t("orphan.reference")))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "filter-item-content" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.Reference,
                          expression: "Reference",
                        },
                      ],
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.Reference,
                      },
                      attrs: {
                        id: "orphan-reference",
                        type: "text",
                        placeholder: _vm.$t("orphan.reference"),
                      },
                      domProps: { value: _vm.Reference },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.Reference = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "filter-item mb-5",
                  attrs: { sm: "6", lg: "3", cols: "12" },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "filter-item-title",
                      attrs: { for: "orphan-name" },
                    },
                    [_vm._v(_vm._s(_vm.$t("orphan.name")))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "filter-item-content" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.Name,
                          expression: "Name",
                        },
                      ],
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.Name,
                      },
                      attrs: {
                        id: "orphan-name",
                        type: "text",
                        placeholder: _vm.$t("orphan.name"),
                      },
                      domProps: { value: _vm.Name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.Name = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item col-4 mb-5 text-truncate" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "filter-item-title text-ellipsis",
                      attrs: { title: _vm.$t("orphan.matching_result_label") },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("orphan.matching_result_label")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "filter-item-content d-flex justify-content-between p-1 pt-2",
                      attrs: {
                        id:
                          "msgType-picker-link" +
                          "-" +
                          _vm.filterType +
                          "-" +
                          _vm.randomString,
                        href: "#",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          class:
                            "fixed-span-size " +
                            (_vm.messageTypeDisplay.nb > 0
                              ? "filter-item-input-complete"
                              : ""),
                        },
                        [_vm._v(_vm._s(_vm.messageTypeDisplay.label))]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa-light fa-chevron-down",
                        attrs: { size: "17px", id: "msgType-chevron" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-popover",
                    {
                      attrs: {
                        target:
                          "msgType-picker-link" +
                          "-" +
                          _vm.filterType +
                          "-" +
                          _vm.randomString,
                        title: _vm.$t("orphan.selected_matching_result_none"),
                        triggers: "focus",
                        placement: "bottom",
                      },
                    },
                    _vm._l(_vm.resultTypeList, function (type, index) {
                      return _c(
                        "span",
                        {
                          key:
                            _vm.$t("orphan.matching_result." + type.id) +
                            "-" +
                            index,
                        },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: { value: 1, "unchecked-value": 0 },
                              model: {
                                value: type.state,
                                callback: function ($$v) {
                                  _vm.$set(type, "state", $$v)
                                },
                                expression: "type.state",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("orphan.matching_result." + type.id)
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "filter-item mb-5",
                  attrs: { sm: "6", lg: "3", cols: "12" },
                },
                [
                  _c("datetime-picker-custom", {
                    staticClass: "z-1",
                    class: {
                      "filter-item-input": true,
                      "filter-item-input-complete": _vm.dateBegin,
                    },
                    attrs: {
                      format: "DD/MM/YYYY H:i:s",
                      inputLabel: _vm.$t("common.date_start_label"),
                      customInputParentClass: "filter-item-content",
                      customInputClass: "w-100",
                      maxLength: 19,
                      placeholderValue: _vm.$t(
                        "common.datetime_picker_empty_date"
                      ),
                      inputIcon: "fa-solid fa-calendar",
                    },
                    model: {
                      value: _vm.dateBegin,
                      callback: function ($$v) {
                        _vm.dateBegin = $$v
                      },
                      expression: "dateBegin",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "filter-item mb-5",
                  attrs: { sm: "6", lg: "3", cols: "12" },
                },
                [
                  _c("datetime-picker-custom", {
                    staticClass: "z-1",
                    class: {
                      "filter-item-input": true,
                      "filter-item-input-complete": _vm.dateEnd,
                    },
                    attrs: {
                      format: "DD/MM/YYYY H:i:s",
                      inputLabel: _vm.$t("common.date_end_label"),
                      customInputParentClass: "filter-item-content",
                      customInputClass: "w-100",
                      maxLength: 19,
                      placeholderValue: _vm.$t(
                        "common.datetime_picker_empty_date"
                      ),
                      inputIcon: "fa-solid fa-calendar",
                    },
                    model: {
                      value: _vm.dateEnd,
                      callback: function ($$v) {
                        _vm.dateEnd = $$v
                      },
                      expression: "dateEnd",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-row-reverse mt-3 pr-0",
                  attrs: { lg: "3", cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.applyFilter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.srch")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-3",
                      attrs: { size: "sm", disabled: !_vm.hasInputFilter },
                      on: { click: _vm.clearFilterFields },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("filter.clr_fltr_field")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.items.length > 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter_2 mx-3",
                  on: {
                    click: function ($event) {
                      return _vm.extractCSV()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-upload fs-14px" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "fab-label" }, [
                    _vm._v(_vm._s(_vm.$t("common.extract_list"))),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activateSpinner
        ? _c("spinner", { staticClass: "mt-3" })
        : _c(
            "div",
            [
              _vm.items.length
                ? _c("b-table", {
                    staticClass: "table table-striped",
                    attrs: {
                      hover: "",
                      items: _vm.items,
                      fields: _vm.fields,
                      selectable: _vm.items.length > 0,
                    },
                    on: { "row-selected": _vm.seeOrphansDetails },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(CreationDate)",
                          fn: function (data) {
                            return [
                              _c("div", { staticClass: "text-ellipsis" }, [
                                _vm._v(
                                  _vm._s(_vm._f("formatDateTime")(data.value))
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "cell(Reference)",
                          fn: function (data) {
                            return [
                              _c("div", { staticClass: "text-ellipsis" }, [
                                _vm._v(_vm._s(data.value)),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "cell(Name)",
                          fn: function (data) {
                            return [
                              _c("div", { staticClass: "text-ellipsis" }, [
                                _vm._v(
                                  _vm._s(
                                    data.item.CompanyName != ""
                                      ? data.item.CompanyName
                                      : data.item.FirstName +
                                          " " +
                                          data.item.LastName
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "cell(MatchingResult)",
                          fn: function (data) {
                            return [
                              _c("div", { staticClass: "text-ellipsis" }, [
                                _vm._v(
                                  _vm._s(
                                    data.item.IdScore != ""
                                      ? data.item.IdScore
                                      : data.item.NameScore
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "cell(Type)",
                          fn: function (data) {
                            return [
                              _c("div", { staticClass: "text-ellipsis" }, [
                                _vm._v(_vm._s(data.item.Type)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      579409867
                    ),
                  })
                : _c("div", { staticClass: "d-flex justify-content-center" }, [
                    _c("span", { staticClass: "noResult" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.no_result")) +
                          "\n      "
                      ),
                    ]),
                  ]),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("cm-pagination", {
                    attrs: {
                      maxResultsByPage: _vm.paginationObject.maxResults,
                      firstIndex: _vm.paginationObject.firstIndex,
                      nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                      refreshEvent: _vm.paginationObject.refresh,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }